import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage/LoginPage';
// import AccountPage from './components/AccountPage/AccountPage';
import DownLoadPage from './components/DownLoadPage/DownLoadPage';
// import Mining from './components/MiningPage/Mining';
// import PreferencePage from './components/PreferencePage/PreferencePage';
import Logout from './components/Logout/Logout';
import NotFoundPage from './components/NotFoundPage/NotFoundPage';
import RegistrationPage from './components/RegistrationPage/RegistrationPage';
import RecoveryPassPage from './components/RecoveryPassPage/RecoveryPassPage';
import Protected from './hoc/Protected';
import { useDispatch } from 'react-redux';
import { authSuccess } from './redux/Slices/authDataSlice';

function App() {
  const dispatch = useDispatch();

  if (localStorage.getItem('userID') && localStorage.getItem('userToken')) {
    let user = {
      user_id: localStorage.getItem('userID'),
      token: localStorage.getItem('userToken'),
    };

    dispatch(authSuccess(user));
  }

  return (
    <div className="App">
      <Routes>
        {/* <Route
          path="/account"
          element={
            <Protected>
              <AccountPage />
            </Protected>
          }
        />
        <Route
          path="/mining"
          element={
            <Protected>
              <Mining />
            </Protected>
          }
        />
        <Route
          path="/preference"
          element={
            <Protected>
              <PreferencePage />
            </Protected>
          }
        /> */}
        <Route
          path="/logout"
          element={
            <Protected>
              <Logout />
            </Protected>
          }
        />
        <Route
          path="/download"
          element={
            <Protected>
              <DownLoadPage />
            </Protected>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route path="/recovery-pass" element={<RecoveryPassPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
